import moment from 'moment';
import { IConfiguracoesEscala, getConfiguracoesEscalaPadrao } from '../models/escala.configuracoes.model';

type ValorConfiguracao = string | number | boolean | undefined;

function valorConfiguracaoAtivo(valor: ValorConfiguracao): boolean {
    return valor === true || valor === 'true' || valor === 1 || valor === '1';
}

export function montarDataFechamentoCalendario(
    configuracoesEscala: IConfiguracoesEscala,
    dataBase: moment.Moment = moment()
): string {
    if (!configuracoesEscala.USA_SLA_CALENDARIO) {
        return '';
    }

    const diaFechamento = parseInt(configuracoesEscala.FECHAMENTO_CALENDARIO, 10);
    if (isNaN(diaFechamento) || diaFechamento <= 0) {
        return '';
    }

    let mes = dataBase.month() + 1;
    let ano = dataBase.year();

    if (configuracoesEscala.CALENDARIO_FECHA_PROXIMO_MES) {
        mes += 1;
        if (mes === 13) {
            mes = 1;
            ano += 1;
        }
    }

    const ultimoDiaMes = moment({ year: ano, month: mes - 1 }).daysInMonth();
    const dia = diaFechamento > ultimoDiaMes ? ultimoDiaMes : diaFechamento;

    return moment({ year: ano, month: mes - 1, date: dia }).format('YYYY-MM-DD');
}

/**
 * Lê as configurações do calendário do globals ($rootScope.configuracoes), que já as traz no login.
 * A tela de Configurações atualiza esse mesmo objeto ao salvar, mas grava o valor cru (string),
 * enquanto o globals entrega boolean/número: por isso a normalização aceita os dois formatos.
 */
export function carregarConfiguracoesEscala(configuracoes?: Record<string, unknown>): IConfiguracoesEscala {
    const configuracoesEscala = getConfiguracoesEscalaPadrao();
    if (!configuracoes) {
        return configuracoesEscala;
    }

    const fechamentoCalendario = configuracoes.FECHAMENTO_CALENDARIO;

    return {
        ...configuracoesEscala,
        USA_SLA_CALENDARIO: valorConfiguracaoAtivo(configuracoes.USA_SLA_CALENDARIO as ValorConfiguracao),
        FECHAMENTO_CALENDARIO: fechamentoCalendario === null || fechamentoCalendario === undefined ? '' : String(fechamentoCalendario),
        CALENDARIO_FECHA_PROXIMO_MES: valorConfiguracaoAtivo(configuracoes.CALENDARIO_FECHA_PROXIMO_MES as ValorConfiguracao),
    };
}

export function formatarDataFechamentoCalendario(configuracoesEscala: IConfiguracoesEscala): string {
    const dataFechamentoCalendario = montarDataFechamentoCalendario(configuracoesEscala);

    return dataFechamentoCalendario
        ? moment(dataFechamentoCalendario, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : '';
}
